// General variables
const $scrollAboveHeight = 100;
const $bgImageHeight = 150;

// Functions
function offsetAnchor() {
    if (location.hash.length !== 0) {
        window.scrollTo(window.scrollX, window.scrollY - $scrollAboveHeight);
    }
}

// Include content from Assets (source: https://www.w3schools.com/howto/howto_html_include.asp)
function includeHTML() {
    var z, i, elmnt, file, xhttp;
    /* Loop through a collection of all HTML elements: */
    z = document.getElementsByTagName("*");
    for (i = 0; i < z.length; i++) {
        elmnt = z[i];
        /*search for elements with a certain atrribute:*/
        file = elmnt.getAttribute("w3-include-html");
        if (file) {
            /* Make an HTTP request using the attribute value as the file name: */
            xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
                if (this.readyState == 4) {
                    if (this.status == 200) {elmnt.innerHTML = this.responseText;}
                    if (this.status == 404) {elmnt.innerHTML = "Page not found.";}
                    /* Remove the attribute, and call this function once more: */
                    elmnt.removeAttribute("w3-include-html");
                    includeHTML();
                }
            }
            xhttp.open("GET", file, true);
            xhttp.send();
            /* Exit the function: */
            return;
        }
    }
}

// Initialization
$('#homepage-main > div').addClass('d-flex row mb-5');
$('#homepage-main > div > p').addClass('pt-3');
$('#realizations > div').addClass('col-12');

// Fading navbar
$(window).scroll(function() {
    $('nav').toggleClass('scrolled', $(this).scrollTop() > $bgImageHeight);
});

// CARDS
// Toggle popup on
$('.open-project').on('click', function() {
    const buttonID = $(this).attr('id');
    const popupID = buttonID.replace("link-", "");
    $('#' + popupID).toggleClass('d-none');
});

// Toggle popup off
$('.popup').on('click', function (e) {
    e.stopPropagation();
    if (e.target == this)  {
        $(this).toggleClass('d-none');
    }
});

$('.close-popup').on('click', function () {
    $(this).parent().parent().toggleClass('d-none');
});


// Responsive columns
$('#projects .card').addClass('col-lg-3 col-md-6 col-11 m-3');
$('#hobbies .card').addClass('col-md-5 col-11 m-3');
$('#contact .contact-col').addClass('col-md-3 col-11 p-2 text-center');

includeHTML();
